// // src/components/ModuleProtectedRoute.tsx
// import { useAuth } from "../src/hooks/useAuth";
// import { Navigate, Outlet, useLocation } from "react-router-dom";
// import { ReactNode } from "react";
// import { useEffect, useState } from "react";

// interface ModuleProtectedRouteProps {
//   moduleId: string;
//   children?: ReactNode;
//   redirectPath?: string;
// }

// const ModuleProtectedRoute = ({
//   moduleId,
//   redirectPath = '/',
//   children,
// }: ModuleProtectedRouteProps) => {
//   const { isAuthenticated, isLoading, hasModuleAccess } = useAuth();
//   const location = useLocation();
//   const [isReady, setIsReady] = useState(false);
//   useEffect(() => {
//     if (!isLoading) {
//       setIsReady(true);
//     }
//   }, [isLoading]);

//   if (!isReady) {
//     return <div></div>;
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/" state={{ from: location }} replace />;
//   }

//   if (!hasModuleAccess(moduleId)) {
//     return <Navigate to={redirectPath} state={{ from: location }} replace />;
//   }

//   return <>{children ? children : <Outlet />}</>;
// };

// export default ModuleProtectedRoute;
import { useAuth } from "../src/hooks/useAuth";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ReactNode, useEffect, useState } from "react";
import { moduleRoutes } from "./Config/moduleRoutes";

interface ModuleProtectedRouteProps {
  moduleId: string;
  children?: ReactNode;
  redirectPath?: string; // optional fallback
}

const ModuleProtectedRoute = ({
  moduleId,
  redirectPath,
  children,
}: ModuleProtectedRouteProps) => {
  const { isAuthenticated, isLoading, hasModuleAccess, getAvailableModules } = useAuth();
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setIsReady(true);
    }
  }, [isLoading]);

  if (!isReady) {
    return <div></div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Agar module ka access nahi hai
  if (!hasModuleAccess(moduleId)) {
    const availableModules = getAvailableModules();

    if (availableModules.length > 0) {
      // First available module ka path nikalo
      const firstModule = availableModules[0];
      const path = Object.keys(moduleRoutes).find(
        (route) => moduleRoutes[route] === firstModule.moduleId
      );

      if (path) {
        return <Navigate to={path} replace />;
      }
    }

    // Agar kuch bhi available nahi hai, to fallback
    return <Navigate to={redirectPath || "/"} replace />;
  }

  return <>{children ? children : <Outlet />}</>;
};

export default ModuleProtectedRoute;
